module.exports = __webpack_public_path__ + "img/bottom2.d6106799.png";